import { Dialog } from 'primereact/dialog'
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid'
import { usePrecisionReportEntry } from '../../Hooks/Features/TalentMatrix/usePrecisionReportEntry'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';
import _ from "underscore"
import { MultiSelect } from 'primereact/multiselect';
import { getPreviousMonths } from '../../utils/Helper';
import { useCommon } from '../../Hooks/Common/useCommon';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown';

const PrecisionReportEntry = ({ precisionReport, setPrecisionReport, filterValues }) => {

    const { columns, data, validateReport, selectedRow, precisionDetailsExportToExcel, confirmationPopup, setConfirmationPopup, search, setSearch, loader, listRef, showInfo, isHide, popupFilter, setPopupFilter, getPrecisionReport } = usePrecisionReportEntry({ precisionReport, filterValues });
    const { getValuePermission } = useCommon();

    return (
        <Dialog visible={precisionReport?.show} onHide={() => setPrecisionReport({ show: false, data: [] })} className='modal-xlarge' style={{ minHeight: "50vh" }} modal={true} draggable={false} header={() => <div>Precision Report (Total: {data?.rowData?.length})</div>}>
            <div className='d-flex justify-content-between gap-2 mb-2'>
                <div className='d-flex gap-1 align-items-center w70'>
                    <input type='text' onChange={(e) => setSearch(e.target.value)} value={search} className='sk-input-dd' placeholder='Search Member' />
                    <div className='w25'>
                        <MultiSelect
                        className='sk-multiselect'
                            placeholder='Month'
                            options={getPreviousMonths(12)}
                            value={popupFilter?.months}
                            onChange={(e) => { setPopupFilter((prev) => ({ ...prev, months: e.value, isChange: true })); }}
                            filter filterInputAutoFocus
                            onHide={() => { if (popupFilter?.isChange) { setPopupFilter((prev) => ({ ...prev, apiCall: true, isChange: false })) } }}
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'months', options.months, (val) => setPopupFilter((prev) => ({ ...prev, months: val, isChange: true })), () => { })}
                        />
                    </div>
                    <div className='w50'>
                        <CommonFilterDropdown
                            fields={[
                                { key: "users", label: "Users", col: 6 },
                                { key: "precision_lead", label: "Leads", col: 6, type: "dropdown", isHide: getValuePermission("precision_entry_lead_dropdown") },
                            ]}
                            filterValues={popupFilter}
                            setFilterValues={setPopupFilter} />
                    </div>
                </div>
                <div className='d-flex gap-2'>
                    <button className='sk-btn sk-btn-primary' onClick={() => getPrecisionReport(listRef.current?.scrollTop)} title='Refresh'><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                    <button className='sk-btn sk-btn-primary' onClick={precisionDetailsExportToExcel}>
                        <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
                    </button>
                    {
                        !isHide && <button className='sk-btn text-white bg-black sk-btn-primary' onClick={() => {
                            if (selectedRow?.length > 0) {
                                setConfirmationPopup(true)
                            } else {
                                showInfo("warn", "Please select at least one employee report");
                            }
                        }}>
                            Submit
                        </button>
                    }
                </div>
            </div>
            <div className="mt-2" style={{ height: "calc(85vh - 100px)", overflowY: "auto", }} ref={listRef}>
                <div>
                    <CommonGrid
                        columns={columns}
                        data={[{ title: "", id: 'all', children: data?.rowData }]}
                        expandAll={true}
                        headerHeight={60}
                        rowHeight={50}
                        strippedTable={true}
                        loader={loader}
                    />
                </div>

            </div>
            < CommanDialog visible={confirmationPopup} handleClose={() => setConfirmationPopup(false)} handleFun={() => { validateReport(selectedRow) }} message={`Are you sure you want to submit ${_.map(selectedRow?.filter(emp => emp.is_save && !emp?.is_submit), "user_display_name").join(", ")} user(s)?`} />
        </Dialog>
    )
}

export default PrecisionReportEntry
